<template>
    <div class="add-processing-step">
        <div class="title is-4">{{ step.name }}</div>
        <div class="columns">
            <div class="column is-one-half-desktop">
                <b-field label="Wählen">
                    <b-select
                        v-model="addStep.optionId"
                        placeholder="step.name"
                        expanded
                    >
                        <option
                            v-for="option in step.options"
                            :value="option._id"
                        >
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-one-quarter-desktop">
                <b-field label="Anzahl">
                    <b-numberinput
                        v-model="addStep.quantity"
                        :controls="false"
                        expanded
                    ></b-numberinput>
                </b-field>
            </div>
            <div
                class="column is-one-quarter-desktop is-flex is-align-items-flex-end"
            >
                <b-button
                    type="is-primary-dark"
                    :disabled="!requiredFieldsAreFilled"
                    expanded
                    @click="this.addProcessingStep"
                >
                    Hinzufügen
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AddStep',
    data() {
        return {
            addStep: {
                optionId: '',
                quantity: 0,
            },
        };
    },
    computed: {
        ...mapGetters(['cartItemByID']),
        requiredFieldsAreFilled() {
            return (
                this.addStep.optionId.length > 0 && this.addStep.quantity > 0
            );
        },
        cartItemProcessingSteps() {
            let cartItem = this.cartItemByID(this.cartItemId);
            if (cartItem.processingSteps) {
                return cartItem.processingSteps;
            } else return [];
        },
    },
    props: {
        step: {
            type: Object,
            required: true,
        },
        cartItemId: {
            type: String,
            required: true,
        },
    },
    methods: {
        async addProcessingStep() {
            let processingSteps = [...this.cartItemProcessingSteps];
            processingSteps.push({
                ...this.addStep,
                stepId: this.step.id,
                ...this.step,
                option: this.step.options.find((_id) => this.addStep.optionId),
                quantity: this.addStep.quantity,
            });
            await this.$store.dispatch('updateCartItemByID', {
                cartItemId: this.cartItemId,
                processingSteps,
            });
        },
    },
};
</script>

<style scoped></style>
